import { faSortDown } from '@fortawesome/pro-solid-svg-icons/faSortDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select } from '@mantine/core';
import { useIntl } from 'react-intl';

import { dropdownMessages } from './dropdown-messages';
import styles from './Dropdown.module.css';

import type { SelectProps } from '@mantine/core';

export const Dropdown = (props: SelectProps) => {
  const intl = useIntl();
  return (
    <Select
      nothingFoundMessage={intl.formatMessage(dropdownMessages.nothingFound)}
      searchable
      rightSection={<FontAwesomeIcon className={styles.icon} icon={faSortDown} size='xs' />}
      {...props}
    />
  );
};
